import {apiRequest, apiFileUpload} from '../../utils/apiHelper'
import {HTTP_CALL_TYPE, API_URL_RESOURCE, MY_ACCOUNT_URL} from '../../utils/constants'

const createRequestPayload = (formData, key) => {
    let data = {}
    if (key) {
        data[key] = []
        data[key].push(formData)
    } else data = {...formData}

    return data
}

export const getMyAccountAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {}
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0
            ? response.error.message === 'No records found'
                ? []
                : response
            : response.success)
    )
}

export const getResourceDetails = async (endpoint, inputData, requestHeaders) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + '/clientprogram/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const getClientProgramAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {}
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const getClientProgramAPIDataObject = async (
    endpoint,
    inputData = {},
    requestHeaders = {}
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.GET
    )
    return response
}

export const validateClinicianNPI = async (npi, key, action, requestHeaders = {}) => {
    const actionUrl =
        action === 'edit'
            ? 'cliententity/validatenpi/' + npi + '/' + key
            : 'cliententity/validatenpi/' + npi
    const response = await apiRequest(
        API_URL_RESOURCE.URL + actionUrl,
        {},
        requestHeaders,
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0
            ? []
            : response.success.cliententityproviders[0])
    )
}

export const postMyAccountAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.POST
    )
    // return (
    if (keyentity === 'technicalsurvey') return response
    else
        return (
            response.hasOwnProperty('error') &&
            (Object.keys(response.error).length > 0 ? false : true)
        )
    // )
}

export const postMyAccountAPIResponseObject = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const postMyAccountAPIFileUpload = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity
) => {
    const response = await apiFileUpload(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.POST
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? response : response)
    )
}
export const putMyAccountAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity = ''
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.PUT
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? false : true)
    )
}

export const putMyAccountAPIResponseObject = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity = ''
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.PUT
    )
    return response
}

export const deleteMyAccountAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {}
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/' + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.DELETE
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? false : true)
    )
}

export const postAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + endpoint, //+ 'myaccount/'
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.POST
    )
    return response
    // .hasOwnProperty('error') &&
    // (Object.keys(response.error).length > 0 ? false : true)
}

export const putAPIData = async (
    endpoint,
    inputData = {},
    requestHeaders = {},
    keyentity
) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + endpoint,
        createRequestPayload(inputData, keyentity),
        requestHeaders,
        HTTP_CALL_TYPE.PUT
    )
    return response
    // .hasOwnProperty('error') &&
    // (Object.keys(response.error).length > 0 ? false : true)
}

export const getAPIData = async (endpoint, inputData = {}, requestHeaders = {}) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0
            ? response.error.message === 'No records found'
                ? []
                : response
            : response.success)
    )
}

export const deleteAPIData = async (endpoint, inputData = {}, requestHeaders = {}) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + endpoint,
        inputData,
        requestHeaders,
        HTTP_CALL_TYPE.DELETE
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? false : true)
    )
}
export const getBulkUpload = async clientObject => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'myaccount/cliententity/importcliniciancount',
        {},
        {
            'client-entity-id': clientObject.cliententityid,
        },
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const getClientEnrollmentStatus = async (rowId, cliententityid) => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + `cliententity/practice/enrollment/${rowId}`,
        {},
        {
            'client-entity-id': cliententityid,
        },
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0
            ? false
            : response.success.enrollmentcomplete)
    )
}

export const getUploadedFile = async e => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + '/myaccount/cliententity/failednpilist/' + e.fileid,
        {},
        {},
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? response : response.success)
    )
}

//
export const getClientEntityProgramList = async cliententityid => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/role/programs',
        {},
        {
            'client-entity-id': cliententityid,
        },
        HTTP_CALL_TYPE.GET
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? response : response.success)
    )
}
